import React from 'react';
import Chip from '@material-ui/core/Chip';
import T from 'i18n-react';

class RequiredChip extends React.Component {
  constructor() {
    super();

    this.chipRef = React.createRef();
  }

  componentDidMount() {
    const application = document.getElementById('applicationFixed');
    if (application) {
      const button = application.querySelector('input[type="submit"]');
      if (button) button.disabled = true;
    }
  }

  componentWillUnmount() {
    //TODO: Remove this function after all profile fields are replaced by react component
    // Check all elements with required marks
    const elements = Array.from(
      document.querySelectorAll('.required-mark, .RequiredChip'),
    );
    if (elements.filter((e) => e !== this.chipRef.current).length === 0) {
      const application = document.getElementById('applicationFixed');
      if (application) {
        const button = application.querySelector('input[type="submit"]');
        button && button.removeAttribute('disabled');
      }
    }
  }

  render() {
    return (
      <Chip
        className="RequiredChip"
        label={T.translate('requiredText')}
        ref={this.chipRef}
        size="small"
        style={{
          backgroundColor: '#FF103E',
          borderRadius: 30,
          color: '#fff',
          cursor: 'inherit',
          fontSize: 10,
          width: 45,
          height: 16,
          fontWeight: 'bold',
        }}
      />
    );
  }
}

export default RequiredChip;
